import * as CL from '@design-system/component-library';
import { dsClass } from '../../../common/constants/dsClasses.js';
import { costCenterAndReferenceMsg, costCenterToolTipMsg, referenceToolTipMsg, t } from '../../../common/i18n';
import { CostCenter } from '../../../common/react-hook-form/fields/CostCenter.js';
import { Reference } from '../../../common/react-hook-form/fields/Reference.js';
import { GridColumn } from '../../BillingAccountDetails/components/GridColumn.js';

interface CostCenterAndEmployeeNumberProps {
  fieldPrefix?: string;
  isCostCenterMandatory?: boolean;
  showTitle?: boolean;
}

export const PurposeOfUseCostCenterAndEmployeeNumber = ({
  fieldPrefix = '',
  isCostCenterMandatory = false,
  showTitle = true,
}: CostCenterAndEmployeeNumberProps) => {
  return (
    <div className={showTitle ? dsClass.PADDING_TOP_2 : dsClass.PADDING_0}>
      {showTitle && (
        <h5
          className={`${dsClass.MARGIN_BOTTOM_1} ${dsClass.MARGIN_TOP_3}`}
        >{`${t.JBEM(costCenterAndReferenceMsg)}`}</h5>
      )}
      <CL.Grid className={showTitle ? dsClass.PADDING_TOP_2 : dsClass.PADDING_0}>
        <CL.GridRow className="of-purpose-of-use__grid_row of-purpose-of-use__cost_center_employee_number">
          <GridColumn className="of-purpose-of-use__grid_col">
            <CostCenter
              name={`${fieldPrefix}costCenter`}
              tooltip={`${t.UE8R(costCenterToolTipMsg)}`}
              required={isCostCenterMandatory}
            />
          </GridColumn>
          <GridColumn className="of-purpose-of-use__grid_col">
            <Reference name={`${fieldPrefix}employeeNumber`} tooltip={`${t.HBBD(referenceToolTipMsg)}`} />
          </GridColumn>
        </CL.GridRow>
      </CL.Grid>
    </div>
  );
};
